import React, { useEffect, useState } from 'react';
import Select from "react-select";
import './CountrySelect.css';

const CountrySelect = ({ setSelectedCountryName }) => {
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({});

    useEffect(() => {
        fetch(
            "https://valid.layercode.workers.dev/list/countries?format=select&flags=true&value=code"
        )
            .then((response) => response.json())
            .then((data) => {
                setCountries(data.countries);
                setSelectedCountry(data.userSelectValue);
            });
    }, []);
    return (
        <Select
            className='z_index'
            options={countries}
            value={selectedCountry}
            onChange={(selectedOption) => {
                setSelectedCountry(selectedOption)
                setSelectedCountryName(selectedOption.label)
            }}
        />
    );
};

export default CountrySelect;